import { Box, Typography } from '@mui/material'

type EmptyListStateProps = {
  message: string
}

const containerSx = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  minHeight: '50vh',
  margin: '0px 150px 0px 20px',
  '@media (max-width:900px)': {
    margin: 0,
  },
}

export const EmptyListState = ({ message }: EmptyListStateProps) => (
  <Box sx={containerSx}>
    <Typography variant="h3" color="text.secondary">
      {message}
    </Typography>
  </Box>
)
